var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticStyle:{"margin-top":"-2px"},attrs:{"small":"","color":"secondary"},on:{"click":_vm.openDialog}},[_c('v-icon',{attrs:{"size":"20"}},[_vm._v("mdi-map")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }